var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar',{on:{"clickBar":_vm.toggleNavbar}}),_c('app-navigation',{attrs:{"mini-sidebar":_vm.miniSidebar}}),_c('v-main',[_c('div',{staticClass:"pt-10 pb-10"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }